module.exports = __webpack_public_path__ + "img/Zsofi.08ce914b.jpg";